module.exports = __webpack_public_path__ + "img/tortellini-alle-erbe.93701d07.png";